<template>
  <v-facility-flight-board departures
                           :mobile-sort-value="sortValue"
                           :mobile-search="search"
                           :company="company">
  </v-facility-flight-board>
</template>

<script>
import filterLoads from '@/mixins/filterLoads';
import bookedLoadMixin from '@/mixins/bookedLoadMixin';
import facilityFlightBoardMixin from '@/mixins/facilityFlightBoardMixin';
import VFacilityFlightBoard from '@/components/dashboard/simple/FacilityFlightBoard';

export default {
  name: 'Departures',
  mixins: [
    filterLoads,
    bookedLoadMixin,
    facilityFlightBoardMixin,
  ],
  components: {
    VFacilityFlightBoard,
  },
  props: {
    company: {
      type: Object,
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Companies/Receiving/Departures.vue